'use strict';

var tslib_es6 = require('./tslib.es6-130a177d.js');
var styled = require('styled-components');
var typography_index = require('./typography/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var iconSize = styled.css(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n    width: 48px;\n    height: 48px;\n    padding: 14px;\n"], ["\n    width: 48px;\n    height: 48px;\n    padding: 14px;\n"])));
var DeliveryInfoBlock = styled__default['default'].div.withConfig({ displayName: "ww-uikit_DeliveryInfoBlock_lty9a18x", componentId: "sc-9cvek3" })(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n    ", "\n    display: grid;\n    grid-template-columns: 48px 1fr;\n    grid-template-rows: minmax(48px, min-content);\n    justify-content: center;\n    align-items: center;\n    color: ", ";\n\n    &:not(:last-child) {\n        border-bottom: 1px solid ", ";\n    }\n"], ["\n    ", "\n    display: grid;\n    grid-template-columns: 48px 1fr;\n    grid-template-rows: minmax(48px, min-content);\n    justify-content: center;\n    align-items: center;\n    color: ", ";\n\n    &:not(:last-child) {\n        border-bottom: 1px solid ", ";\n    }\n"])), typography_index.body2, function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal100;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.charcoal20;
});
var templateObject_1, templateObject_2;

exports.DeliveryInfoBlock = DeliveryInfoBlock;
exports.iconSize = iconSize;
//# sourceMappingURL=common-135480f3.js.map
